import { CreateProcess } from "../Classes/CreateProcess";
import axios from "axios";
const url = "/api/process";

//If the user is interested it takes him to the apply page.
export const axiosProcess = async (processId, contactId, branchId) => {
  let info;
  await axios
    .get(`${url}/${contactId}/${processId}/${branchId}`)
    .then((res) => {
      info = res.data;
    });
  return info;
};

export const axiosCreateProcess = async (contactId, serviceOrderId) => {
  let createProcess = new CreateProcess(contactId, serviceOrderId);
  let result;
  await axios.post(`${url}`, createProcess).then((res) => {
    result = res;
  });
  return result;
};
